import React from 'react';
import ButtonsGeneric from '../../../../../../../components/NovoSistema/ButtonsGeneric';
import { ContainerSection } from '../../../../../../../components/NovoSistema/ContainerSection';
import TableCalcCompOutCusD from '../../../../../../../components/NovoSistema/TableCalcCompOutCusD';

export default function OutrosCustosDiretos() {
  return (
    <main>
      <div>
        <ContainerSection>
          <TableCalcCompOutCusD />
        </ContainerSection>
        <ButtonsGeneric>
          <button className="success">Cadastrar</button>
          <button className="error">Cancelar</button>
        </ButtonsGeneric>
      </div>
    </main>
  );
}
